export default __webpack_public_path__ + "static/media/emblem.67c39112.svg";